var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404Right(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 511,
    height: 485,
    viewBox: "0 0 511 485",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_276_2862",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 511,
    height: 485
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 511,
    height: 485,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_276_2862)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 748,
    r: 781,
    fill: "#353A4D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 739.216,
    cy: 749.216,
    r: 683.679,
    fill: "#353A4D",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 739.217,
    cy: 749.217,
    r: 553.513,
    fill: "#353A4D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 738,
    cy: 748,
    r: 339.407,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Right);
export default __webpack_public_path__ + "static/media/404-right.5c863b4d4a3a1b1dcf5275f73a9a2013.svg";
export { ForwardRef as ReactComponent };